import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./app-shell/AppShell";
import { DashboardPage } from "./pages/Dashboard/DashboardPage";
import { ProductsPage } from "./pages/Products/ProductsPage";
import { ProductEditorPage } from "./pages/Products/ProductEditorPage";
import { FiscalizationHubPage } from "./pages/Fiscalization/FiscalizationHubPage";
import { EfakturaPage } from "./pages/Efaktura/EfakturaPage";
import { SalesDocumentsPage } from "./pages/Sales/SalesDocumentsPage";
import { SalesDocumentEditorPage } from "./pages/Sales/SalesDocumentEditorPage";
import { SalesDocumentDetailPage } from "./pages/Sales/SalesDocumentDetailPage";
import { CustomersPage } from "./pages/Customers/CustomersPage";
import { RecurringInvoicesPage } from "./pages/RecurringInvoices/RecurringInvoicesPage";
import { RecurringInvoiceEditorPage } from "./pages/RecurringInvoices/RecurringInvoiceEditorPage";
import { PublicOfferPage } from "./pages/Public/PublicOfferPage";
import { OffersPage } from "./pages/Admin/OffersPage";
import { PublicQuotePage } from "./pages/Public/PublicQuotePage";
import { PublicInvoicePage } from "./pages/Public/PublicInvoicePage";
import { PublicDeliveryNotePage } from "./pages/Public/PublicDeliveryNotePage";
import { BankStatementsPage } from "./pages/BankStatements/BankStatementsPage";
import { BankStatementDetailPage } from "./pages/BankStatements/BankStatementDetailPage";
import { SupportTicketsPage } from "./pages/SupportTickets/SupportTicketsPage";
import { ExpensesPage } from "./pages/Expenses/ExpensesPage";
import { EarhivPage } from "./pages/Earhiv/EarhivPage";
import { NormativPage } from "./pages/Normativ/NormativPage";
import { LojaltiPage } from "./pages/Lojalti/LojaltiPage";
import { WispPage } from "./pages/Wisp/WispPage";
import { HorecaKnjigePage } from "./pages/Horeca/HorecaKnjigePage";
import { HorecaIzvestajiPage } from "./pages/Horeca/HorecaIzvestajiPage";
import { HorecaPopisPage } from "./pages/Horeca/HorecaPopisPage";
import { HorecaLayout } from "./pages/Horeca/HorecaLayout";
import { EotpremnicePage } from "./pages/Eotpremnice/EotpremnicePage";
import { HorecaKuhinjaPage } from "./pages/Horeca/HorecaKuhinjaPage";
import { HorecaPodesavanjaPage } from "./pages/Horeca/HorecaPodesavanjaPage";
import { SupportTicketDetailPage } from "./pages/SupportTickets/SupportTicketDetailPage";
import { CompanySettingsPage } from "./pages/CompanySettings/CompanySettingsPage";
import { GoodsReceiptsPage } from "./pages/GoodsReceipts/GoodsReceiptsPage";
import { IntegrationsPage } from "./pages/Integrations/IntegrationsPage";
import { ReportsPage } from "./pages/Reports/ReportsPage";
import { LoginPage } from "./pages/Auth/LoginPage";
import { SignupPage } from "./pages/Auth/SignupPage";
import { ConfirmAccountPage } from "./pages/Auth/ConfirmAccountPage";
import { ForgotPasswordPage } from "./pages/Auth/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/Auth/ResetPasswordPage";
import { OnboardingPage } from "./pages/Onboarding/OnboardingPage";
import { AdminUsersPage } from "./pages/Admin/AdminUsersPage";
import { SuperAdminPage } from "./pages/Admin/SuperAdminPage";
import { PlatformUsersPage } from "./pages/Admin/PlatformUsersPage";
import { CompanyDetailPage } from "./pages/Admin/CompanyDetailPage";
import { DeviceDetailPage } from "./pages/Admin/DeviceDetailPage";
import { ModuleGroupsPage } from "./pages/Admin/ModuleGroupsPage";
import { ServiceEndpointsPage } from "./pages/Admin/ServiceEndpointsPage";
import { EmailSettingsPage } from "./pages/Admin/EmailSettingsPage";
import { EmailTemplatesPage } from "./pages/Admin/EmailTemplatesPage";
import { PackagesPage } from "./pages/Admin/PackagesPage";
import { AppReleasesAdminPage } from "./pages/Admin/AppReleasesAdminPage";
import { PrintAgentsAdminPage } from "./pages/Admin/PrintAgentsAdminPage";
import { ContractTemplatesPage } from "./pages/Admin/ContractTemplatesPage";
import { BackupPage } from "./pages/Admin/BackupPage";
import { EarhivStoragePage } from "./pages/Admin/EarhivStoragePage";
import { WispAdminPage } from "./pages/Admin/WispAdminPage";
import { HubAdminPage } from "./pages/Admin/HubAdminPage";
import { LpfrAdminPage } from "./pages/Admin/LpfrAdminPage";
import { LogsPage } from "./pages/Admin/LogsPage";
import { SupportTicketsAdminPage } from "./pages/Admin/SupportTicketsAdminPage";
import { MyPackagePage } from "./pages/Billing/MyPackagePage";
import { MyInvoicesPage } from "./pages/Billing/MyInvoicesPage";
import { MyContractPage } from "./pages/Billing/MyContractPage";
import { RequireAuth } from "./app-shell/RequireAuth";

export function App() {
  return (
    <Routes>
      <Route path="/pregled/ponuda/:token" element={<PublicQuotePage />} />
      <Route path="/ponuda/:token" element={<PublicOfferPage />} />
      <Route path="/pregled/racun/:token" element={<PublicInvoicePage />} />
      <Route path="/pregled/otpremnica/:token" element={<PublicDeliveryNotePage />} />
      <Route path="/prijava" element={<LoginPage />} />
      <Route path="/registracija" element={<SignupPage />} />
      <Route path="/potvrda-naloga" element={<ConfirmAccountPage />} />
      <Route path="/zaboravljena-lozinka" element={<ForgotPasswordPage />} />
      <Route path="/reset-lozinke" element={<ResetPasswordPage />} />

      <Route element={<RequireAuth />}>
        {/* Van AppShell-a (bez sidebar-a) - vidi mockup, wizard je celoekranski. */}
        <Route path="/onboarding" element={<OnboardingPage />} />

        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />

          <Route path="/prodaja" element={<SalesDocumentsPage />} />
          <Route path="/prodaja/nova-ponuda" element={<SalesDocumentEditorPage type="QUOTE" />} />
          <Route path="/prodaja/nova-faktura" element={<SalesDocumentEditorPage type="INVOICE" />} />
          <Route path="/prodaja/:id/izmeni" element={<SalesDocumentEditorPage />} />
          <Route path="/prodaja/:id" element={<SalesDocumentDetailPage />} />

          <Route path="/ponavljajuce-fakture" element={<RecurringInvoicesPage />} />
          <Route path="/ponavljajuce-fakture/nova" element={<RecurringInvoiceEditorPage />} />

          <Route path="/fiskalizacija" element={<FiscalizationHubPage />} />
          <Route path="/efakture" element={<EfakturaPage />} />
          <Route path="/artikli" element={<ProductsPage />} />
          <Route path="/artikli/novi" element={<ProductEditorPage />} />
          <Route path="/artikli/:id/izmeni" element={<ProductEditorPage />} />

          <Route path="/kupci" element={<CustomersPage />} />
          <Route path="/izvodi" element={<BankStatementsPage />} />
          <Route path="/izvodi/:id" element={<BankStatementDetailPage />} />
          <Route path="/podrska" element={<SupportTicketsPage />} />
          <Route path="/troskovi" element={<ExpensesPage />} />
          <Route path="/e-arhiv" element={<EarhivPage />} />
          <Route path="/normativ" element={<NormativPage />} />
          <Route path="/lojalti" element={<LojaltiPage />} />
          <Route path="/wisp" element={<WispPage />} />
          <Route path="/horeca" element={<HorecaLayout />}>
            <Route index element={<Navigate to="/horeca/kuhinja" replace />} />
            <Route path="kuhinja" element={<HorecaKuhinjaPage />} />
            <Route path="izvestaji" element={<HorecaIzvestajiPage />} />
            <Route path="popis" element={<HorecaPopisPage />} />
            <Route path="knjige" element={<HorecaKnjigePage />} />
            <Route path="normativ" element={<NormativPage />} />
            <Route path="lojalti" element={<LojaltiPage />} />
            <Route path="podesavanja" element={<HorecaPodesavanjaPage />} />
          </Route>
          <Route path="/eotpremnice" element={<EotpremnicePage />} />
          <Route path="/podrska/:id" element={<SupportTicketDetailPage />} />
          <Route path="/izvestaji" element={<ReportsPage />} />
          <Route path="/prijem-robe" element={<GoodsReceiptsPage />} />
          <Route path="/integracije" element={<IntegrationsPage />} />
          <Route path="/podesavanja" element={<CompanySettingsPage />} />
          <Route path="/moj-paket" element={<MyPackagePage />} />
          <Route path="/moji-racuni" element={<MyInvoicesPage />} />
          <Route path="/moj-ugovor" element={<MyContractPage />} />
          <Route path="/admin/korisnici" element={<AdminUsersPage />} />
          <Route path="/finora-admin" element={<SuperAdminPage />} />
          <Route path="/finora-admin/users" element={<PlatformUsersPage />} />
          <Route path="/finora-admin/logs" element={<LogsPage />} />
          <Route path="/finora-admin/podrska" element={<SupportTicketsAdminPage />} />
          <Route path="/finora-admin/companies/:id" element={<CompanyDetailPage />} />
          <Route
            path="/finora-admin/companies/:companyId/devices/:deviceId"
            element={<DeviceDetailPage />}
          />
          <Route path="/finora-admin/billing" element={<ModuleGroupsPage />} />
          <Route path="/finora-admin/services" element={<ServiceEndpointsPage />} />
          <Route path="/finora-admin/settings/services" element={<ServiceEndpointsPage />} />
          <Route path="/finora-admin/settings/email" element={<EmailSettingsPage />} />
          <Route path="/finora-admin/email-templates" element={<EmailTemplatesPage />} />
          <Route path="/finora-admin/packages" element={<PackagesPage />} />
          <Route path="/finora-admin/ponude" element={<OffersPage />} />
          <Route path="/finora-admin/print-agents" element={<PrintAgentsAdminPage />} />
          <Route path="/finora-admin/app-releases" element={<AppReleasesAdminPage />} />
          <Route path="/finora-admin/contract-templates" element={<ContractTemplatesPage />} />
          <Route path="/finora-admin/backup" element={<BackupPage />} />
          <Route path="/finora-admin/earhiv-s3" element={<EarhivStoragePage />} />
          <Route path="/finora-admin/lpfr" element={<LpfrAdminPage />} />
          <Route path="/finora-admin/hub" element={<HubAdminPage />} />
          <Route path="/finora-admin/wisp" element={<WispAdminPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
